import { setupComponentLibrary } from '@campsite-bio/component-lib';

export default ({ $config }) => {
  setupComponentLibrary({
    apiBaseUrl: $config.apiBaseUrl,
    env: $config.envType,
    assetCdn: $config.cdnHost,
    assetsBucketName: $config.assetsBucketName,
  });
};
